import { theme } from '@pocketlaw/tetris';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
export const SearchResultContainer = styled.div `
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: ${theme.spacing.md};
  padding-bottom: ${theme.spacing.lg};
`;
export const resultItemStyle = css `
  display: flex;
  width: 100%;
  align-items: center;
  padding: ${theme.spacing.md};
  gap: ${theme.spacing.md};
  scroll-margin: ${theme.spacing.lg};
`;
export const SkeletonItemContainer = styled.div `
  ${resultItemStyle}
`;
export const StyledLink = styled(Link) `
  ${resultItemStyle}
  text-decoration: none;

  ${({ $highlighted }) => $highlighted &&
    css `
      background-color: ${theme.semantic.surface.secondary};
      border-radius: ${theme.borderRadius.md};
    `}
`;
export const Highlight = styled.strong `
  font-weight: ${theme.fontWeight.semibold};
`;
